module.exports = __webpack_public_path__ + "producr-dried fresh-grass-06.jpg?bf783ed3fbe3a1f52c1badca387ddd48";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-06.jpg
// module id = 64
// module chunks = 0